var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset52(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 328.37 44.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b3d3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,16.83a8.08,8.08,0,0,1,2.1-4.25,15.6,15.6,0,0,1,3.65-2.9,35.92,35.92,0,0,1,8.37-3.33A86.81,86.81,0,0,1,31.61,3.77a158.41,158.41,0,0,1,17.57.16Q57.94,4.58,66.62,6C72.37,7,78.19,7.85,84,9.15a63.53,63.53,0,0,1,16.92,6.25,54.32,54.32,0,0,1,14.76,11.42c4.22,4.71,7.44,10.73,7.86,16.93l-1.28.55a50.68,50.68,0,0,0-12.92-9.82A110.33,110.33,0,0,0,95,28.13c-5-1.85-10-3.72-15.06-5.8a144.63,144.63,0,0,0-15.7-5.44C58.9,15.4,53.47,14.14,48,13.11A150.88,150.88,0,0,0,31.5,10.73,85.57,85.57,0,0,0,15,10.63,32.51,32.51,0,0,0,7,12.34c-2.45.91-4.85,2.35-5.67,4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327,14.74c-.74-2.46-3.08-4-5.49-5a32.9,32.9,0,0,0-7.83-1.95,86.37,86.37,0,0,0-16.49-.42,150.25,150.25,0,0,0-16.51,1.86q-8.22,1.29-16.29,3.26a116,116,0,0,0-15.63,5.07c-5.05,2-10,3.89-15,5.7a155.92,155.92,0,0,0-14.62,6.16,79.1,79.1,0,0,0-7,3.86,50.4,50.4,0,0,0-6.78,4.93l-1.24-.66a20.34,20.34,0,0,1,1.25-4.5,27.49,27.49,0,0,1,2.09-4.21,40.81,40.81,0,0,1,5.73-7.39,60.31,60.31,0,0,1,14.75-11,62,62,0,0,1,16.94-6.11c5.84-1.25,11.72-2,17.51-2.81S274,.32,279.78.08a157.42,157.42,0,0,1,17.51.39,86.59,86.59,0,0,1,17.34,3.11,35.56,35.56,0,0,1,8.24,3.6,15.25,15.25,0,0,1,3.54,3,8.06,8.06,0,0,1,2,4.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset52);
export default __webpack_public_path__ + "static/media/Asset 52.6b3068ef.svg";
export { ForwardRef as ReactComponent };